/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/currency';
import '../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "pricingplan": {
        "nested": {
          "service": {
            "nested": {
              "PricingPlanClassification": {
                "values": {
                  "PRICING_PLAN_CLASSIFICATION_UNKNOWN": 0,
                  "PRICING_EXPERIMENT_V0": 1,
                  "PRICING_EXPERIMENT_V1": 2,
                  "PRICING_EXPERIMENT_TIERED_V1": 11,
                  "PRICING_EXPERIMENT_V2": 3,
                  "DUAL_MODE_V1": 4,
                  "AUTOMATED_PRICING_DISCOUNT_V2": 5,
                  "UNIT_TEST": 6,
                  "CBD_PRICING": 7,
                  "PRICING_EXPERIMENT_V2_NO_HARDWARE": 8,
                  "DUAL_MODE_V2": 9,
                  "DUAL_MODE_V3": 10,
                  "MODERN_MICROS_M0": 12,
                  "JP_PNP_PRICING_EXPERIMENT": 13,
                  "AU_PRICE_ELASTICITY_TEST_2025": 14,
                  "RESELLER_PROGRAM": 15,
                  "JP_ZENINREN_PRICING": 16,
                  "JP_HERO_INNOVATIONS": 17,
                  "JP_IZA_PRICING": 18,
                  "AU_NAB_PRICING": 19
                }
              },
              "PricingPlanOffer": {
                "nested": {
                  "OfferType": {
                    "values": {
                      "UNKNOWN": 0,
                      "AUTOMATED_PRICING_DISCOUNT_V2_US": 1,
                      "AUTOMATED_PRICING_DISCOUNT_V2_GB": 2,
                      "AUTOMATED_PRICING_DISCOUNT_V2_AU": 3
                    }
                  }
                }
              },
              "TerminationConditions": {
                "fields": {
                  "feeAmount": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "minimumBilledMonths": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "TerminationStatus": {
                "fields": {
                  "returnInitiated": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "monthsBilled": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "returnByDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "FeePlanRate": {
                "fields": {
                  "defaultCpBasisPoints": {
                    "type": "uint32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "defaultCpInterchangeCents": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cpBasisPoints": {
                    "type": "uint32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cpInterchangeCents": {
                    "type": "uint32",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "FetchFlag": {
                "values": {
                  "NONE": 0,
                  "RETURN_STATUS": 1,
                  "BILLING_STATUS": 2
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.PricingPlanClassification && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.PricingPlanOffer?.nested?.OfferType && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.TerminationConditions && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.TerminationStatus && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.FeePlanRate && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.FetchFlag) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE PricingPlanClassification @ squareup/pricingplan/common.proto at 11:1
 */
export const PricingPlanClassification = $root.lookupEnum('squareup.pricingplan.service.PricingPlanClassification').values;
/**
 * SOURCE PricingPlanOffer @ squareup/pricingplan/common.proto at 40:1
 */
export const PricingPlanOffer = {};
/**
 * SOURCE OfferType @ squareup/pricingplan/common.proto at 41:3
 */
PricingPlanOffer.OfferType = $root.lookupEnum('squareup.pricingplan.service.PricingPlanOffer.OfferType').values;
/**
 * SOURCE TerminationConditions @ squareup/pricingplan/common.proto at 122:1
 */
export const TerminationConditions = $root.lookupType('squareup.pricingplan.service.TerminationConditions');
fixType(TerminationConditions, {
  feeAmount: {
    required: true
  },
  minimumBilledMonths: {
    required: true
  }
});
Builder.createAndAttachToType(TerminationConditions);
/**
 * SOURCE TerminationStatus @ squareup/pricingplan/common.proto at 130:1
 */
export const TerminationStatus = $root.lookupType('squareup.pricingplan.service.TerminationStatus');
fixType(TerminationStatus);
Builder.createAndAttachToType(TerminationStatus);
/**
 * SOURCE FeePlanRate @ squareup/pricingplan/common.proto at 142:1
 */
export const FeePlanRate = $root.lookupType('squareup.pricingplan.service.FeePlanRate');
fixType(FeePlanRate);
Builder.createAndAttachToType(FeePlanRate);
/**
 * SOURCE FetchFlag @ squareup/pricingplan/common.proto at 156:1
 */
export const FetchFlag = $root.lookupEnum('squareup.pricingplan.service.FetchFlag').values;